
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.5.667a.833.833 0 01.097 1.66l-.097.006H3.167a.833.833 0 00-.828.736l-.006.098v11.666c0 .428.322.78.736.828l.098.006H6.5a.833.833 0 01.097 1.66l-.097.006H3.167A2.5 2.5 0 01.67 14.98l-.004-.147V3.167A2.5 2.5 0 013.02.67l.147-.004H6.5zm10.735 8.727l-.006.01a.827.827 0 01-.07.107l-.016.02a.838.838 0 01-.043.048l-.01.01-4.167 4.167a.833.833 0 01-1.248-1.1l.07-.079 2.743-2.744H6.5a.833.833 0 01-.097-1.66l.097-.006h7.988l-2.744-2.744a.833.833 0 01-.07-1.1l.07-.079c.3-.3.773-.323 1.1-.07l.079.07 4.166 4.167.01.01a.838.838 0 01.062.071l-.072-.081a.84.84 0 01.244.589v.046a.838.838 0 01-.003.033L17.333 9a.837.837 0 01-.098.394z","fill":"#FFF","fill-rule":"evenodd"}})])
          )
        }
      }
    